// Imports
import { useEffect, useState } from "react";

export default function Transition() {

// Consts
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
    let path
        
// Background size for Transition
    useEffect(() => {
        const isNowMobile = window.innerWidth <= 768
        if (isMobile !== isNowMobile) {
            setIsMobile(isNowMobile)
        }
    }, [isMobile])

    if(isMobile) {path = "M 0 0.97 V 0 C 0.4149 0.03 0.6064 0.03 1 0 V 0.97 C 0.6667 1.01 0.3333 1.01 0 0.97 Z"}
    else {path = "M 0 0.92 V 0 C 0.4149 0.05 0.6064 0.05 1 0 V 0.93 C 0.6667 1.02 0.3333 1.02 0 0.93 Z"}

    return (<>
        <div id="overlayTransition" className="">
            {/*<svg className="overlay-background" preserveAspectRatio="none" viewBox="0 0 1 1">*/}
            {/*    <path fill="#ffffff" d={path} />*/}
            {/*</svg>*/}
        </div>

        <svg className="overlay-logo" id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.36 94.36"><g id="Calque_1-2"><g><rect className="cls-2" x="12.71" y="41.73" width="32.45" height="10.91" transform="translate(57.86 94.36) rotate(180)"/><rect className="cls-2" x="26.2" y="31.73" width="30.89" height="10.91" transform="translate(78.84 -4.46) rotate(90)"/><path className="cls-2" d="M47.05,55.2h-10.86c0,5.49,4.26,14.54,10.86,17.42v-17.42Z"/><path className="cls-1" d="M0,47.18c0,9.12,2.61,17.64,7.11,24.87V22.31C2.61,29.54,0,38.06,0,47.18Z"/><path className="cls-1" d="M47.18,10.89c14.16,0,26.44,8.16,32.42,20.01h11.86C84.82,12.88,67.48,0,47.18,0c-9.54,0-18.42,2.86-25.85,7.74v14c6.59-6.69,15.74-10.85,25.85-10.85Z"/><path className="cls-1" d="M94.05,41.84v-.08s0,0,0,0h-31.41v10.85h20.44c-2.63,17.45-17.72,30.86-35.88,30.86-10.11,0-19.27-4.16-25.85-10.85v14c7.43,4.89,16.31,7.74,25.85,7.74,26.02,0,47.18-21.16,47.18-47.18,0-1.81-.12-3.59-.31-5.35Z"/><path className="cls-2" d="M21.33,72.62V21.74c-6.45,6.55-10.44,15.54-10.44,25.44s3.99,18.88,10.44,25.44Z"/></g></g></svg>
    </>)
}